import * as React from 'react';
import { get, union } from 'lodash';
import { compose, withHandlers } from 'recompose';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { connect } from 'react-redux';
import { formatDate } from '@utils/utils';

const enhance = compose<any, any>(
  reduxForm({ form: 'statistics-employees-modal' }),
  connect<any, any, any>(
    (state, { oldValues }) => ({
      oldEmployees: formValueSelector('exportButton-dialog')(state, oldValues)
    }),
    (dispatch, { oldValues }) => ({ saveEmployees: value => dispatch(change('exportButton-dialog', oldValues, value)) })
  ),
  withHandlers({
    onSubmit: ({ oldEmployees, saveEmployees, closeItem }) => async ({ shiftCycle }) => {
      const { employees } = shiftCycle;
      const newEmployees = union(oldEmployees, employees.map(({ id }) => id));

      saveEmployees(newEmployees);
      closeItem();
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, onSubmit }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit(onSubmit)}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Zvolte cyklus směny</h4>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  name={'shiftCycle'}
                  label={'Cyklus směny'}
                  url={'/metropolis/api/hr/workplan/shift/cycle'}
                  fullWidth={true}
                  labelFunction={o =>
                    `${get(o, 'label')} (${formatDate(get(o, 'from'))} - ${formatDate(get(o, 'to'))})`
                  }
                  valueFunction={o => o}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Button label="Přidat strážníky" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsExportStatisticsShiftCyclesModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsExportStatisticsShiftCyclesModal.tsx